import React from 'react'
import { MapView } from './map.view'

interface IProps {
	handleClick: (id: string) => void
}

export const MapContainer = ({ handleClick }: IProps) => {
	return <MapView handleClick={handleClick} />
}
